import PartnersList from './PartnersList';
import PartnerShow from './PartnerShow';

export default {
  list: PartnersList,
  show: PartnerShow,
};
